const PRODUCT_ACTION_TYPES = {
  LOAD_PRODUCTS: 'product/LOAD_PRODUCTS',
};

export default PRODUCT_ACTION_TYPES;
